import { render, staticRenderFns } from "./addAgent.vue?vue&type=template&id=383e1364&scoped=true&lang=pug"
import script from "./addAgent.vue?vue&type=script&lang=js"
export * from "./addAgent.vue?vue&type=script&lang=js"
import style0 from "./addAgent.vue?vue&type=style&index=0&id=383e1364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e1364",
  null
  
)

export default component.exports